export type ItemTypeLike = string | null | undefined;

export const ITEM_TYPE_BADGE_CLASS = {
  produto: "bg-blue-100 text-blue-700 hover:bg-blue-100 hover:text-blue-700",
  servico: "bg-green-100 text-green-700 hover:bg-green-100 hover:text-green-700",
  pacote: "bg-violet-100 text-violet-700 hover:bg-violet-100 hover:text-violet-700",
};

export const getItemTypeBadgeClass = (kind?: ItemTypeLike) => {
  if (!kind) return null;

  const normalized = String(kind).toLowerCase();

  if (["produto", "medicamento"].includes(normalized)) {
    return ITEM_TYPE_BADGE_CLASS.produto;
  }

  if (["serviço", "servico", "service"].includes(normalized)) {
    return ITEM_TYPE_BADGE_CLASS.servico;
  }

  if (["pacote", "package"].includes(normalized)) {
    return ITEM_TYPE_BADGE_CLASS.pacote;
  }

  return null;
};
